var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.openSaleDetails.apply(null, arguments)}}},[(_vm.invoice)?_c('span',[_vm._v(_vm._s(_vm.$t('sale.invoice_number', {invoice: _vm.invoice}))+" ")]):_c('span',{directives:[{name:"t",rawName:"v-t",value:('sale.invoice_title'),expression:"'sale.invoice_title'"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }